import { type FragmentOf, graphql } from 'gql.tada';

/**
 * Suburbs for a city, one level deep. Named `CitySuburbsFragment` (not
 * `SuburbFragment`) to avoid clashing with the existing `SuburbFragment` in `@discover-data/gql/fragments/suburb`, which selects different fields.
 */
const CitySuburbsFragment = graphql(`
  fragment CitySuburbsFragment on City {
    id
    title
    menuTitle
    suburbs {
      edges {
        node {
          id
          menuTitle
        }
      }
    }
  }
`);

export default CitySuburbsFragment;

export type CitySuburbsType = FragmentOf<typeof CitySuburbsFragment>;
